module.exports = __webpack_public_path__ + "img/horizontal_4_6_r_8004.d9c394ae.png";